var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22276 1.41307C1.65202 0.979585 2.4085 1.0407 2.91241 1.54958L15.0778 13.8349C15.5817 14.3438 15.6423 15.1078 15.213 15.5412C14.7837 15.9747 14.0273 15.9136 13.5234 15.4047L1.35794 3.11937C0.854028 2.6105 0.79351 1.84656 1.22276 1.41307Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.777235 15.4131C0.34798 14.9796 0.408498 14.2156 0.912407 13.7068L13.0778 1.4214C13.5817 0.912523 14.3382 0.851408 14.7675 1.2849C15.1967 1.71838 15.1362 2.48232 14.6323 2.9912L2.46688 15.2766C1.96297 15.7854 1.20649 15.8466 0.777235 15.4131Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6e9bf07cdf6f8c7ffefad801aa088d56.svg";
export { ForwardRef as ReactComponent };